import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Navegacion from "../components/BarraNavegacion";
import Footer from "../components/Footer";
import CardTicket from "../components/CardTicket";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Col,
  Container,
  Image,
  ProgressBar,
  Row,
  Button,
  Form,
  Spinner,
  Modal,
} from "react-bootstrap";
import Gorra from "../Assets/diamante.png";
import Souldout from "../Assets/Soldoud.jpg";
import Card from "react-bootstrap/Card";
import {
  collection,
  onSnapshot,
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase-config";
import Swal from "sweetalert2";

function Home() {
  const [countTickets, setCountTickets] = useState(0);
  const navigate = useNavigate();
  const [portada, setPortada] = useState("");
  const [titulo, setTitulo] = useState("");
  const [price, setPrice] = useState(null);
  const [CountPrecio, setCountPrecio] = useState(0);
  const [sorteoActivo, setSorteoActivo] = useState(true); // 🔥 Agregar esta línea
  const [porcentajeVendidos, setPorcentajeVendidos] = useState(0);
  const [loading, setLoading] = useState(true);
  const [TicketsDisponibles, setTicketsDisponibles] = useState(0);
  const [minCompras, setminCompras] = useState(2);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [idSorteo, setIdSorteo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const verificarPagoPendiente = async () => {
      const transactionId = localStorage.getItem("transactionId"); // 🔍 Buscar la transacción en localStorage

      if (!transactionId) return; // Si no hay transacción, no mostramos el modal

      const transaccionRef = doc(db, "transacciones", transactionId);
      const transaccionSnap = await getDoc(transaccionRef);

      if (transaccionSnap.exists() && transaccionSnap.data().pagoPendiente) {
        setMostrarModal(true);
      }
    };

    verificarPagoPendiente();
  }, []);

  function MasBoletas() {
    if (countTickets + 1 <= TicketsDisponibles) {
      setCountTickets(countTickets + 1);
      setCountPrecio(parseFloat(CountPrecio) + parseFloat(price * 1));
    } else {
      Swal.fire({
        icon: "error",
        title: "No hay suficientes boletos disponibles",
        text: `Solo quedan ${TicketsDisponibles} boletos disponibles.`,
        confirmButtonColor: "#000000",
        confirmButtonText: "Cerrar",
      });
    }
  }
  function MenosBoletas() {
    if (minCompras < countTickets) {
      setCountTickets(countTickets - 1);
      setCountPrecio(parseFloat(CountPrecio) - parseFloat(price * 1));
    }
  }

  function seleccionarOpcionCompra(cantidad) {
    setCountTickets(cantidad);
    setCountPrecio(Number(price) * cantidad);
    iniciarProcesoCompra(cantidad);
  }

  async function iniciarProcesoCompra(cantidadSeleccionada) {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const cantidadNumerica = Number(cantidadSeleccionada);
    const restantesLuegoDeCompra = TicketsDisponibles - cantidadNumerica;

    if (
      !Number.isFinite(cantidadNumerica) ||
      cantidadNumerica <= 0 ||
      cantidadNumerica < Number(minCompras)
    ) {
      Swal.fire({
        icon: "error",
        title: "Cantidad no valida",
        text: `La compra minima es de ${minCompras} boletos.`,
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    if (!idSorteo || !Number.isFinite(Number(price))) {
      Swal.fire({
        icon: "error",
        title: "Sorteo no disponible",
        text: "No se pudo cargar la informacion del sorteo.",
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    if (cantidadNumerica > TicketsDisponibles) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Solo quedan ${TicketsDisponibles} boletos disponibles.`,
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    if (restantesLuegoDeCompra > 0 && restantesLuegoDeCompra < minCompras) {
      const puedesComprar = TicketsDisponibles - minCompras;
      const oComprarTodo = TicketsDisponibles;

      Swal.fire({
        icon: "warning",
        title: "Compra no valida",
        html: `
        Esta compra dejaria pocos tickets disponibles.<br><br>
        Puedes comprar <b>${puedesComprar}</b> para dejar el minimo,<br>
        o comprar todos los disponibles: <b>${oComprarTodo}</b>.
      `,
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    try {
      navigate(`/finalizar-compra/${cantidadNumerica}`, {
        state: {
          price,
          titulo,
          countTickets: cantidadNumerica,
          idSorteo,
        },
      });
    } catch (error) {
      console.error("No se pudo abrir el formulario de pago.", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo abrir el formulario de pago.",
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) return; // Previene múltiples clics
    setIsSubmitting(true); // 🔒 Bloquea el botón

    const restantesLuegoDeCompra = TicketsDisponibles - countTickets;

    if (countTickets > TicketsDisponibles) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Solo quedan ${TicketsDisponibles} boletos disponibles.`,
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    if (restantesLuegoDeCompra > 0 && restantesLuegoDeCompra < minCompras) {
      const puedesComprar = TicketsDisponibles - minCompras;
      const oComprarTodo = TicketsDisponibles;

      Swal.fire({
        icon: "warning",
        title: "Compra no válida",
        html: `
        Esta compra dejaría pocos tickets disponibles.<br><br>
        Puedes comprar <b>${puedesComprar}</b> para dejar el mínimo,<br>
        o comprar todos los disponibles: <b>${oComprarTodo}</b>.
      `,
        confirmButtonColor: "#000000",
      });
      setIsSubmitting(false);
      return;
    }

    try {
      // Navegar inmediatamente al formulario de pago para reducir la espera.
      navigate(`/finalizar-compra/${countTickets}`, {
        state: {
          price,
          titulo,
          countTickets,
          idSorteo,
        },
      });
    } catch (error) {
      console.error("❌ Error al navegar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo abrir el formulario de pago.",
        confirmButtonColor: "#000000",
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  useEffect(() => {
    const verificarTicketsPendientes = async () => {
      const storedTransactionId = localStorage.getItem("transactionId");
      if (!storedTransactionId) return;

      const transaccionRef = doc(db, "transacciones", storedTransactionId);
      const transaccionSnap = await getDoc(transaccionRef);

      if (
        transaccionSnap.exists() &&
        transaccionSnap.data().status === "APPROVED"
      ) {
        setMostrarModal(true);
      }
    };

    verificarTicketsPendientes();
  }, []);

  useEffect(() => {
    const sorteosRef = collection(db, "sorteos");

    const unsubscribe = onSnapshot(sorteosRef, (querySnapshot) => {
      if (!querySnapshot.empty) {
        const sorteos = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const ultimoSorteo = sorteos.sort(
          (a, b) => b.createdAt - a.createdAt
        )[0];

        setPortada(ultimoSorteo.url);
        setIdSorteo(ultimoSorteo.id);
        setTitulo(ultimoSorteo.title);
        setPrice(ultimoSorteo.price);
        setSorteoActivo(ultimoSorteo.activo);
        setCountTickets(parseFloat(ultimoSorteo.minCompras) + 6);
        setCountPrecio(
          ultimoSorteo.price * (parseFloat(ultimoSorteo.minCompras) + 6)
        );
        setminCompras(parseFloat(ultimoSorteo.minCompras));

        // Escuchar la cantidad de tickets vendidos en tiempo real
        const ticketsRef = collection(db, `sorteos/${ultimoSorteo.id}/tickets`);
        const unsubscribeTickets = onSnapshot(ticketsRef, (querySnapshot) => {
          const vendidos = querySnapshot.size; // Contamos cuántos tickets hay en la colección
          const total = ultimoSorteo.totalNumeros || 100;
          const porcentaje = (vendidos / total) * 100;
          const disponibles = total - vendidos;
          setTicketsDisponibles(disponibles);
          setPorcentajeVendidos(porcentaje);
          setLoading(false);
          if (disponibles <= 0) {
            setSorteoActivo(false);
          }
        });

        return () => unsubscribeTickets(); // Limpia la suscripción a los tickets
      }
    });

    return () => unsubscribe(); // 🔥 Importante: Limpiar el listener al desmontar el componente
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Altura completa de la pantalla
          flexDirection: "column",
        }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando progreso...</span>
        </Spinner>
        <p style={{ marginTop: "10px" }}>Cargando...</p>
      </div>
    );
  }
  const opciones = (() => {
    const res = [];
    const total = 7;
    for (let i = 0; i < total; i++) {
      if (i < 4) res.push(i * 20);
      else res.push(80 + 100 * (i - 3));
    }
    return res;
  })();
  return (
    <div>
      <Navegacion title={"Bienvenido a Chriis store"}></Navegacion>
      <Container fluid className="d-flex flex-column min-vh-100">
        <div>
          {mostrarModal && (
            <Modal show={mostrarModal} onHide={() => setMostrarModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>🎟️ ¡Tienes tickets pendientes!</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Tu pago ha sido aprobado. Puedes revisar tus tickets.
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="dark"
                  onClick={async () => {
                    const transactionId = localStorage.getItem("transactionId");

                    if (transactionId) {
                      setMostrarModal(false);
                      window.location.href = `/confirmacion?id=${transactionId}`;
                    }
                  }}
                >
                  Revisar Tickets
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => setMostrarModal(false)}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {sorteoActivo ? (
            <div>
              <Container>
                {portada && (
                  <Image
                    src={portada}
                    style={{ width: "500px", height: "600px" }}
                    className="mt-3"
                    alt="Portada"
                    fluid
                  />
                )}
                <h3 className="mb-4 mt-3">{titulo}</h3>
              </Container>
              <Row>
                <Col xl={3} className="justify-content-md-center"></Col>
                <Col xl={6} className="justify-content-md-center">
                  <ProgressBar
                    animated
                    now={porcentajeVendidos}
                    label={`${Math.round(porcentajeVendidos)}%`}
                  />
                </Col>
                <Col xl={3} className="justify-content-md-center"></Col>
              </Row>
              <Container className="mt-3">
                <h6>Participa por solo</h6>
                <h2 className="mt-3">
                  {Number(price).toLocaleString("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </h2>
              </Container>
              <Row className="mt-5">
                {opciones.map((incremento, index) => {
                  const cantidad = Number(minCompras) + incremento;
                  const precioUnitario = Number(price);
                  const total =
                    !isNaN(precioUnitario) && !isNaN(cantidad)
                      ? precioUnitario * cantidad
                      : 0;
                  return (
                    <Col lg="4" key={index}>
                      <CardTicket
                        cantidad={cantidad}
                        valor={total}
                        featured={index === 2}
                        selected={Number(countTickets) === cantidad}
                        disabled={isSubmitting}
                        onSelect={seleccionarOpcionCompra}
                        featuredText={"Opción más comprada"}
                        badgeText={index === 4 ? "Mejor oferta 🔥" : index === 6 ? "Máxima probabilidad 💎" : undefined}
                        borderColor={index === 4 ? "#FFA500" : index === 6 ? "#7B3FBF" : undefined}
                      />
                    </Col>
                  );
                })}
              </Row>
              {/* <------------------------ TARJETA INDEPENDIENTE PARA SELECCIONAR CANTIDAD --------------------------------> */}{/* <------------------------ TARJETA INDEPENDIENTE PARA SELECCIONAR CANTIDAD --------------------------------> */}
              <Row className="mt-4">
                <h6 className="mb-3">
                  Selecciona la cantidad que deseas comprar:
                </h6>

                <Container
                    style={{
                      maxWidth: "950px",
                    }}
                >
                  <Card
                      className="shadow-sm mb-5"
                      style={{
                        borderRadius: "20px",
                        border: "none",
                        minHeight: "130px",
                      }}
                  >
                    <Card.Body
                        style={{
                          padding: "1.5rem",
                        }}
                    >
                      <div
                          className="d-flex flex-column flex-lg-row align-items-center justify-content-between gap-4"
                      >
                        {/* Cantidad */}
                        <div className="text-center text-lg-start">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ fontWeight: 700, fontSize: "1.5rem" }}>X</span>
                            <Form.Control
                              type="number"
                              value={countTickets}
                              min={minCompras}
                              max={TicketsDisponibles}
                              onChange={(e) => {
                                const val = e.target.value === "" ? "" : Number(e.target.value);
                                if (val === "") {
                                  setCountTickets("");
                                  setCountPrecio(0);
                                  return;
                                }
                                const bounded = Math.max(Number(minCompras), Math.min(Number(TicketsDisponibles || Infinity), val));
                                setCountTickets(bounded);
                                setCountPrecio(Number(price) * bounded);
                              }}
                              style={{ width: "140px", fontSize: "2rem", fontWeight: 700, textAlign: "center" }}
                            />
                          </div>
                        </div>

                        {/* Precio */}
                        <div className="text-center">
                          <h4 className="mb-0">
                            {Number(CountPrecio).toLocaleString("es-CO", {
                              style: "currency",
                              currency: "COP",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })}
                          </h4>
                        </div>

                        {/* Imagen */}
                        <div className="text-center">
                          <Image
                              src={Gorra}
                              alt="Diamante"
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "contain",
                              }}
                          />
                        </div>

                        {/* Botones + y - */}
                        <div className="d-flex align-items-center gap-2">
                          <Button
                              variant="dark"
                              className="btn-circulo"
                              onClick={MenosBoletas}
                          >
                            -
                          </Button>

                          <Button
                              variant="dark"
                              className="btn-circulo"
                              onClick={MasBoletas}
                          >
                            +
                          </Button>
                        </div>

                        {/* Botón Comprar */}
                        <Form onSubmit={handleSubmit}>
                          <Button
                              type="submit"
                              variant="dark"
                              disabled={isSubmitting}
                              style={{
                                minWidth: "180px",
                                borderRadius: "30px",
                                padding: "12px 24px",
                              }}
                          >
                            {isSubmitting ? (
                                <>
                                  <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                  />{" "}
                                  Procesando...
                                </>
                            ) : (
                                "Comprar"
                            )}
                          </Button>
                        </Form>
                      </div>
                    </Card.Body>
                  </Card>
                </Container>
              </Row>
            </div> // Se muestra si hay boletos
          ) : (
            <div className=" justify-content-center align-items-center vh-100 ">
              <Row>
                <Col lg="12" xs="12" className="mb-4">
                  <Image
                    src={Souldout}
                    style={{ width: "350px", height: "250px" }}
                    className="mt-3"
                    alt="Portada"
                    fluid
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="12" xs="12">
                  <div className="">
                    <h1>¡Ya no quedan numeros disponibles!</h1>
                    <h2 className="mt-2">
                      Te esperamos en la proxima dinamica
                    </h2>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
      </Container>
      <Footer></Footer>
    </div>
  );
}

export default Home;
